<template>
   <div class="users-registered">
      <Modal 
         :show="show" 
         :loading="loading" 
         :icon="UserRegistered.forms.payment_verification.icon" 
         :title="UserRegistered.forms.payment_verification.title" 
         :subtitle="UserRegistered.forms.payment_verification.subtitle" 
         button="Verify"
         @close="$store.commit('show',false)"
         @submit="verifyPayment({ref: $refs[UserRegistered.forms.payment_verification.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="UserRegistered.forms.payment_verification.name" 
               :forms="UserRegistered.forms.payment_verification.forms" 
               :form_data="UserRegistered.forms.payment_verification.data"
            />
         </template>
      </Modal>

      <div class="row justify-content-center">
         <div class="col-12 col-md-7 col-lg-9 col-xl-8">
            <Form 
               classBinding="row" 
               :ref="UserRegistered.forms.query_users_registered.name" 
               :forms="UserRegistered.forms.query_users_registered.forms" 
               :form_data="UserRegistered.forms.query_users_registered.data"
            />
         </div>
         <div class="col-12 col-md-5 col-lg-3 col-xl-4">
            <div class="btn btn-primary btn-padded" :disabled="loading" @click="queryUsersRegistered({ref: $refs[UserRegistered.forms.query_users_registered.name]})">
               Query
               <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
            </div>
         </div>
      </div>

      <Table 
         :icon="UserRegistered.tables.users_registered.icon" 
         :table_fields="UserRegistered.tables.users_registered.table_fields" 
         :table_data="users" 
         :title="UserRegistered.tables.users_registered.title" 
         :search_fields="UserRegistered.tables.users_registered.search_fields"
         :row_data="UserRegistered.tables.users_registered.row_data"
         @on-action="handleActions"
      />

      <div class="row justify-content-end" v-if="users.length > 0">
         <div class="col-12 col-md-4 col-lg-3">
            <div class="btn btn-long btn-primary mt-3" @click="downloadExcel()">Download Report</div>
         </div>
      </div>
   </div>
</template>

<script>
import user_registered from "../rsc/stores/reports/usersRegistered.store";
const XLSX = require('xlsx')

export default {
   beforeDestroy () {
      this.$store.unregisterModule('user_registered')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('user_registered',user_registered,this.$store)
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'UserRegistered',
         'users',
         'show',
         'selectedCustomerData',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
         'verifyPayment',
         'fetchUserRegFormData',
         'queryUsersRegistered',
      ]),
      async handleActions(payload){
         if(payload.action === 'customer:view'){
            await $session.set('selectedCustomer',payload.row);
            this.$router.push({name: 'Customers_Registered-View_Customer'})
         }else if(payload.action === 'customer:verify_payment'){
            if (payload.row.status === 3){
               $notify('warning', 'Payment Already Verified', `Payment for customer ${payload.row.name} is already verified.`)
               return false;
            }

            this.$store.commit('selectedCustomerData',payload.row)
            this.$store.commit('show',true)
         }
      },
      downloadExcel(){
         try{
            if(this.users.length > 0){
               let data = [], sample = {}
               for(let i=0;i<this.users.length;i++){
                  let user = this.users[i]

                  for(let j=0;j<user.cards.length;j++){
                     let card = user.cards[j]
                     card.productRestriction = card.productRestriction.toString()
                     card.authorizedZones = card.authorizedZones.toString()
                     card.daysOfUse = card.daysOfUse.toString()
                     card.mobileNo = card.mobileNo.code.callingCode+''+card.mobileNo.mobile
                     data.push({
                        ...card,
                        name: user.name,
                        verifiedMobileNumber: user.mobileNumber,
                        verifiedEmail: user.email,
                        station: user.station,
                        promoCode: user.promoCode,
                     })
                     
                  }
               }

               var workSheet = XLSX.utils.json_to_sheet(data);
               var wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, workSheet, 'customers');
               XLSX.writeFile(wb, 'customers.xlsx')
            }
         }catch(err){
            console.log(err)
         }
      }
   },
   async mounted(){
      utils.registerModule('user_registered',user_registered,this.$store)
      EventBus.$emit('loader:show', false)
      this.fetchUserRegFormData()
   }
}
</script>

<style lang="scss">
   .users-registered{
      .form-label{
         width: 100%;
      }
   }
</style>